import {cs} from "@Common/react/chain-services";

import {ApprovalConflictModal} from "./approval-conflict-modal/approval-conflict-modal";

export const PromptApprovalConflict = ({cart, next}) => cs(

    ["modal", ({}, next) => ApprovalConflictModal({
        cart, next,
    })],

    ({modal}) => next(({keepIdOrderApproval}) => new Promise((resolve, reject) => {
        modal.show({
            keepIdOrderApproval,
            onSelect: (moveApprovalPending) => resolve(moveApprovalPending),
        });
    })),
);
